import { Point, Polygon, Segment } from '@pixacare/geometry';
import { TypedWorker } from './typed-worker';
import { WoundsizeMeasureSource } from './woundsize-measure-source.enum';

type WoundsizeWorkerInput = { points: Point[]; source: WoundsizeMeasureSource };
type WoundsizeWorkerOutput = { length: Segment; width: Segment; polygon: Polygon; source: WoundsizeMeasureSource };

export class WoundsizeWorker extends TypedWorker<WoundsizeWorkerInput, WoundsizeWorkerOutput> {
  constructor() {
    super(new Worker(new URL('./woundsize.worker', import.meta.url)));
  }
}
